import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { ContactUsData, EduChatUser } from '@app/models';

type ContactFormData = ContactUsData | EduChatUser; // Used to assign either type to function param

@Injectable({
    providedIn: 'root'
})
export class EmailSenderService {
    private API_URL = '/api/emailSender/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(
        private httpClient: HttpClient
    ) { }


    testRoute(): Observable<any> {
        return this.httpClient.get<any>(this.API_URL);
    }


    contactUs(_contactFormData: ContactFormData): Observable<any> {
        return this.httpClient.post<any>(this.API_URL + 'contactUs', JSON.stringify(_contactFormData), this.headerOptions);
    }


    referAFriend(_formData: any): Observable<any> {
        return this.httpClient.post<any>(this.API_URL + 'referAFriend', JSON.stringify(_formData), this.headerOptions);
    }
}